module.exports = __webpack_public_path__ + "static/media/BottomLeftBase.82b8c9df.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/ButtonBases/BottomLeftBase.png
// module id = 48
// module chunks = 0